import KeyValueMap from './_key-value-map.js'
import PrebuiltMatchAccaMarkets from './_prebuilt-match-acca-markets.js'
import LoaderSuspense from './_loader-suspense.js'
import FlexPane from './_flex-pane.js'
import EventMarketsGroupSwitcher from './_event-markets-group-switcher.js'
import AggregatedMarketPane from './_aggregated-market-pane.js'
import GenericMarketContent from './_generic-market-content.js'
import PlayerPropMarketContent from './_player-prop-market-content.js'
import MilestoneMarketContent from './_milestone-market-content.js'
import HandicapMarketContent from './_handicap-market-content.js'
import CorrectScoreMarketContent from './_correct-score-market-content.js'
import GameLineMarketContent from './_game-line-market-content.js'
import GoalScorerMarketContent from './_goal-scorer-market-content.js'
import PriceBoostAggregatedMarket from './_price-boost-aggregated-market.js'
import MarketGroupSelectorSkeleton from './_market-group-selector-skeleton.js'
import EventMarketsSkeleton from './_event-markets-skeleton.js'
import MarketInstructions from './_market-instructions.js'

export default {
  name: 'EventMarkets',
  values: {
    initiallyExpandedMarkets: 4,
    showMatchAccaBuilder: false,
    hidePrebuiltBets: {
      configSet: KeyValueMap,
      configValues: {
        default: false,
      },
    },
    prebuiltBetsPosition: {
      configSet: KeyValueMap,
      configValues: {
        default: 1,
      },
    },
    hidePriceBoostedMarkets: {
      configSet: KeyValueMap,
      configValues: {
        default: false,
      },
    },
    priceBoostedMarketsPosition: {
      configSet: KeyValueMap,
      configValues: {
        default: 2,
      },
    },
    prebuiltMatchAccaMarkets: {
      configSet: PrebuiltMatchAccaMarkets,
      configValues: {
        prebuiltBets: {
          prebuiltBet: {
            prebuiltBetBuilder: {
              view: {
                showCardHeader: false,
              },
            },
          },
        },
      },
    },
    prebuiltMatchAccaMarketsInPivot: {
      configSet: PrebuiltMatchAccaMarkets,
      configValues: {
        prebuiltBets: {
          showCarousel: false,
          prebuiltBet: {
            prebuiltBetBuilder: {
              view: {
                showCardHeader: false,
              },
            },
          },
        },
      },
    },
    skeletonLoader: {
      configSet: LoaderSuspense,
      configValues: {
        style: {
          container: {
            maxWidth: '100%',
          },
          hidden: {
            display: 'block',
            width: '100%',
            position: 'absolute',
            visibility: 'hidden',
            opacity: 0,
            zIndex: -1,
          },
        },
      },
    },
    container: {
      configSet: FlexPane,
      configValues: {
        createStackingContext: true,
        style: {
          maxWidth: '100%',
          flexDirection: 'column',
        },
      },
    },
    marketGroupSwitcher: {
      configSet: EventMarketsGroupSwitcher,
      configValues: {},
    },
    marketsContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          maxWidth: '100%',
          flexDirection: 'column',
          _mobile_padding: '8px',
          boxSizing: 'border-box',
        },
      },
    },
    aggregatedMarketPane: {
      configSet: AggregatedMarketPane,
      configValues: {
        expandable: {
          contentContainer: {
            style: {
              visible: {
                overflow: 'hidden',
              },
            },
          },
        },
      },
    },
    genericMarketContent: {
      configSet: GenericMarketContent,
      configValues: {},
    },
    playerPropMarketContent: {
      configSet: PlayerPropMarketContent,
      configValues: {},
    },
    milestoneMarketContent: {
      configSet: MilestoneMarketContent,
      configValues: {},
    },
    handicapMarketContent: {
      configSet: HandicapMarketContent,
      configValues: {},
    },
    correctScoreMarketContent: {
      configSet: CorrectScoreMarketContent,
      configValues: {},
    },
    gameLineMarketContent: {
      configSet: GameLineMarketContent,
      configValues: {},
    },
    goalScorerMarketContent: {
      configSet: GoalScorerMarketContent,
      configValues: {},
    },
    priceBoostAggregatedMarket: {
      configSet: PriceBoostAggregatedMarket,
      configValues: {},
    },
    priceBoostInitiallyExpanded: true,
    marketGroupSelectorSkeleton: {
      configSet: MarketGroupSelectorSkeleton,
      configValues: {},
    },
    marketsSkeleton: {
      configSet: EventMarketsSkeleton,
      configValues: {},
    },
    matchAccaMarketInstructions: {
      configSet: MarketInstructions,
      configValues: {},
    },
    fastMarketInstructions: {
      configSet: MarketInstructions,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
